export const sortPeriod = periods => {
  let currentYear = new Date()
  periods = periods
    .map(item => {
      let dateSlide
      if (item.period) {
        if (item.period.title) {
          dateSlide = item.period.title.slice(5).trim()
        }
      } else {
        dateSlide = item.title.slice(5).trim()
      }
      if (+dateSlide > 6 && +dateSlide <= 12) {
        item = {
          ...item,
          sort: `${dateSlide}${currentYear.getFullYear()}`
        }
      } else {
        item = {
          ...item,
          sort: `2${dateSlide}${currentYear.getFullYear() + 1}`
        }
      }
      return item
    })
    .sort((a, b) => +a.sort - +b.sort)
  return periods
}

export function getPriceInputPlaceholder(router, isSubFee, type) {
  if (router === 'main') return 'Mức chi (VNĐ)'
  const postfix = type === 'fixed' ? '(VNĐ)' : '(%)'
  if (router === 'adjust') return 'Mức điều chỉnh ' + postfix
  if (router === 'sub') {
    const prefix = isSubFee ? 'Mức hoàn trả' : 'Mức truy thu'
    return prefix + ' ' + postfix
  }
  return ''
}

export const checkDataFileExcel = students => {
  let isError = false
  let indexError = []
  for (let i = 0; i < students.length; i++) {
    students[i].index = i + 1
    if (students[i].price === undefined) {
      indexError.push(i + 1)
      isError = true
    } else if (students[i].code === undefined) {
      indexError.push(i + 1)
      students[i].code = 'Thiếu thông tin'
      isError = true
    } else if (!students[i].type) {
      indexError.push(i + 1)
      students[i].price = 'Lỗi dữ liệu'
      isError = true
    } else if (students[i].type.includes('%') && (students[i].price > 100) | (students[i].price < 0)) {
      indexError.push(i + 1)
      students[i].price = 'Lỗi dữ liệu'
      isError = true
    }
  }
  return { indexError, students, isError }
}

export const schema = {
  'Tên giáo viên': { prop: 'name', type: String },
  'Mã giáo viên': { prop: 'code', type: String },
  'Ngày sinh': {
    prop: 'dob',
    type: String
  },
  'Giới tính': {
    prop: 'gender',
    type: String
  },
  'Trạng thái': {
    prop: 'status',
    type: String
  },
  'Mức thu/giảm': {
    prop: 'price',
    type: String
  },
  'Kiểu giảm trừ': {
    prop: 'type',
    type: String
  },
  'Ghi chú riêng': {
    prop: 'notes',
    type: String
  }
}
export function dataExampleFile(router, isSubFee) {
  let arr = [
    {
      dob: '27/04/2011',
      code: 'huyenkn',
      name: 'Nguyễn Khánh Huyền',
      status: 'Đang dạy',
      gender: 'Nữ',
      money: '2000000',
      type: 'VND',
      notes: ''
    }
  ]
  if (router === 'priority' && isSubFee === false) {
    arr.push({
      name: 'Nguyễn Văn A',
      code: 'anv',
      dob: '27/04/2011',
      gender: 'Nam',
      status: 'Đang dạy',
      money: '20',
      type: '%',
      notes: ''
    })
  }
  return arr
}
export let headerSampleFile = [
  { text: 'Tên giáo viên', value: 'name' },
  { text: 'Mã giáo viên', value: 'code' },
  { text: 'Ngày sinh', value: 'dob' },
  { text: 'Giới tính', value: 'gender' },
  { text: 'Trạng thái', value: 'status' },
  { text: 'Mức thu/giảm', value: 'money' },
  { text: 'Kiểu giảm trừ', value: 'type' },
  { text: 'Ghi chú riêng', value: 'notes' },
  { text: 'Dữ liệu khi upload lên hệ thống được tính từ dòng 2', value: '' }
]

export function header(title, price) {
  return [
    {
      text: title,
      value: 'period.title',
      align: 'left',
      sortable: false,
      show: true,
      width: '50%'
    },
    {
      text: price,
      value: 'price',
      align: 'left',
      sortable: false,
      show: true,
      width: '25%'
    },
    {
      text: 'Thao tác',
      align: 'center',
      value: 'action',
      sortable: false,
      show: true,
      width: '25%'
    }
  ]
}

export function headerPaymentPeriodTable(router, isSubFee) {
  if (router === 'main') return header('Kỳ chi', 'Mức chi (VNĐ)')
  if (router === 'adjust') return header('Kỳ điều chỉnh', 'Mức điều chỉnh')
  if (router === 'sub') {
    if (isSubFee) return header('Kỳ hoàn trả', 'Mức hoàn trả')
    return header('Kỳ truy thu', 'Mức truy thu')
  }
  return ''
}
